import React, { useEffect, useState } from "react";
import { FiActivity } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";

import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

const VitalSignsCard = ({ onExportData }) => {
  const { pid } = useParams();

  const [vitals, setVitals] = useState([]);

  useEffect(() => {
    if (!pid) return;

    fetchVitals();
  }, [pid]);

  const fetchVitals = async () => {
    try {
      const response = await axiosInstance.get(
        `/vozo/patient/VitalInsMed/dashboard?pid=${pid}`,
      );

      let result = Decrypt_Value(response.data, "vozo");

      const vitalData = result?.[0] || {};

      const formattedVitals = [
        {
          label: "Blood Pressure",

          value:
            vitalData.bps_1 && vitalData.bps_2
              ? `${vitalData.bps_1}/${vitalData.bps_2} mmHg`
              : "-",
        },

        {
          label: "Heart Rate",

          value: vitalData.pulse ? `${vitalData.pulse} bpm` : "-",
        },

        {
          label: "Temperature",

          value: vitalData.temperature
            ? (() => {
                const fahrenheit = Number(vitalData.temperature);

                if (isNaN(fahrenheit)) return "-";

                const celsius = (((fahrenheit - 32) * 5) / 9).toFixed(1);

                return `${fahrenheit}°F (${celsius}°C)`;
              })()
            : "-",
        },

        {
          label: "Respiratory Rate",

          value: vitalData.respiration
            ? `${vitalData.respiration} breaths/min`
            : "-",
        },

        {
          label: "Height",

          value: vitalData.height
            ? (() => {
                const totalInches = Number(vitalData.height);

                if (isNaN(totalInches)) return "-";

                const feet = Math.floor(totalInches / 12);

                const inches = totalInches % 12;

                const cm = Math.round(totalInches * 2.54);

                return `${feet}'${inches}" (${cm} cm)`;
              })()
            : "-",
        },

        {
          label: "Weight",

          value: vitalData.weight
            ? (() => {
                const lbs = Number(vitalData.weight);

                if (isNaN(lbs)) return "-";

                const kg = (lbs * 0.453592).toFixed(1);

                return `${lbs} lbs (${kg} kg)`;
              })()
            : "-",
        },
      ];

      setVitals(formattedVitals);

      /* PARENT → FULL DATA */

      if (onExportData) {
        onExportData(
          formattedVitals.map((item) => ({
            label: item.label,
            value: item.value,
          })),
        );
      }
    } catch (error) {
      console.log("Vitals API Error:", error);

      setVitals([]);
    }
  };

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiActivity className="care-summary-main-icon" />

        <h3 className="care-summary-title">Vital Signs</h3>
      </div>

      <div className="vitals-grid">
        {vitals.length === 0 ? (
          <div className="care-summary-empty">No Vital Signs Added</div>
        ) : (
          vitals.map((item, index) => (
            <div className="vital-box" key={index}>
              <div className="vital-label">{item.label}</div>

              <div className="vital-value">{item.value}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(VitalSignsCard);
